import { useState } from "react";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import PrimaryButton from "../components/PrimaryButton";
import { Input } from "../../../../Components/ui/input";
import { BackLink, CardSubtitle, CardTitle } from "../components/AuthCard";
import { CALL_SLOTS } from "../constants";

const fieldLabel = "font-geomanistBold text-xs leading-4 text-blackShade mb-[5px] pl-1 block";

// A8 — reached from A4 or B2 after email + password are validated
const AlternateNumber = ({ header, email, maskedMobile, onSubmit, onBack }) => {
  const [mobile, setMobile] = useState("");
  const [slot, setSlot] = useState(CALL_SLOTS[0]);
  const [consent, setConsent] = useState(false);
  const [touched, setTouched] = useState(false);
  const [loading, setLoading] = useState(false);

  const mobileValid = !!mobile && isValidPhoneNumber(mobile);
  const mobileError = touched && mobile && !mobileValid ? "Enter a valid mobile number" : "";
  const canSubmit = mobileValid && slot && consent && !loading;

  const handleSubmit = async () => {
    if (!canSubmit) return;
    setLoading(true);
    await onSubmit({ mobile, slot });
    setLoading(false);
  };

  return (
    <>
      {header}
      <CardTitle>Update mobile number</CardTitle>
      <CardSubtitle>
        No longer using{" "}
        <span className="font-geomanistBold text-blackShade">{maskedMobile}</span>?
        Share a number we can reach you on. Our Customer Success team will call
        you to verify your identity before updating it.
      </CardSubtitle>

      <div className="mt-5">
        <label htmlFor="registered-email" className={fieldLabel}>
          Registered email ID
        </label>
        <Input
          id="registered-email"
          type="email"
          value={email}
          disabled
          className="font-geomanistBold text-sm text-greyish"
        />
      </div>

      <div className="mt-4">
        <label className={fieldLabel} htmlFor="alternate-mobile">
          Alternate mobile number
        </label>
        <PhoneInput
          id="alternate-mobile"
          international
          countryCallingCodeEditable={false}
          defaultCountry="IN"
          value={mobile}
          onChange={(value) => setMobile(value || "")}
          onBlur={() => setTouched(true)}
          className={`h-10 rounded-md border-[1.5px] bg-white px-3 font-geomanistBold text-sm text-blackShade
            [&_input]:outline-none [&_input]:bg-transparent
            ${mobileError ? "border-failed" : "border-[#D3D4DA] focus-within:border-blackShade"}`}
        />
        {mobileError && (
          <p className="mt-1 mb-0 font-geomanistRegular text-xs leading-4 text-failed">
            {mobileError}
          </p>
        )}
      </div>

      <div className="mt-4">
        <label className={fieldLabel} htmlFor="call-slot">
          Preferred time for the call
        </label>
        <select
          id="call-slot"
          value={slot}
          onChange={(e) => setSlot(e.target.value)}
          className="w-full h-10 rounded-md border-[1.5px] border-[#D3D4DA] bg-white px-3 font-geomanistBold text-sm text-blackShade outline-none focus:border-blackShade cursor-pointer"
        >
          {CALL_SLOTS.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>

      <label
        htmlFor="call-consent"
        className="mt-4 flex items-start gap-2 font-geomanistRegular text-xs leading-5 text-geomanistgray cursor-pointer"
      >
        <input
          id="call-consent"
          type="checkbox"
          checked={consent}
          onChange={(e) => setConsent(e.target.checked)}
          className="mt-[3px] w-4 h-4 accent-[#0061D3] cursor-pointer"
        />
        I authorise Borderless to call me on this number to verify my identity.
      </label>

      <div className="mt-5">
        <PrimaryButton
          title="Submit request"
          onClick={handleSubmit}
          loading={loading}
          disabled={!canSubmit}
        />
      </div>

      <BackLink label="Back to verification" onClick={onBack} />
    </>
  );
};

export default AlternateNumber;
